import React from 'react';
import {Card} from '../../../../_metronic/_partials/controls';
import {NotificationsFilter} from './NotificationsFilter';
import {NotificationsTable} from './NotificationsTable';
import {NotificationsFooter} from './NotificationsFooter';
import FooterBar from '../../_common/components/FooterBar';

export function NotificationsCard() {

  return (
    // @ts-ignore
    <Card className={'flex-fill bg-transparent shadow-none'} id={'notifications-list-card'}>
      <NotificationsFilter/>
      <NotificationsTable/>
      <FooterBar>
        <NotificationsFooter/>
      </FooterBar>
    </Card>
  );
}
